@if (tags?.length) {
  <div class="selected-tags">
    <ul class="selected-tags__list">
      @for (tag of tags; track tag.id) {
        <li class="selected-tags__item">
          <span>#{{ tag.title }}</span>
          <button
            type="button"
            class="selected-tags__remove"
            [attr.aria-label]="removeLabel + ' ' + tag.title"
            (click)="removeTagEvent.emit(tag.id)"
          >
            &times;
          </button>
        </li>
      }
    </ul>

    @if (isModeToggleVisible) {
      <div class="selected-tags__mode">
        <button
          type="button"
          class="selected-tags__mode-button"
          [class.selected-tags__mode-button--active]="mode === 'and'"
          (click)="changeMode('and')"
        >
          {{ andLabel }}
        </button>
        <button
          type="button"
          class="selected-tags__mode-button"
          [class.selected-tags__mode-button--active]="mode === 'or'"
          (click)="changeMode('or')"
        >
          {{ orLabel }}
        </button>
      </div>
    }
  </div>
}
